export const SA_RESOURCE_TOKEN_MINTS = [
  "foodQJAztMzX1DKpLaiounNe2BDMds5RNuPC6jsNrDG",
  "fueL3hBZjLLLJHiFH9cqZoozTG3XQZ53diwFPwbzNim",
  "ammoK8AkX2wnebQb35cDAZtTkvsXQbi82cGeTnUvvfK",
  "tooLsNYLiVqzg8o4m3L2Uetbn62mvMWRqkog6PQeYKL",
];
